export const inputClasses =
  'w-full h-11 rounded-xl border border-slate-200 bg-white px-3.5 text-sm text-slate-900 placeholder:text-slate-400 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-[border-color,box-shadow] duration-150 ease-out-soft hover:border-slate-300 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100';

export const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];

export const popSpring = { type: 'spring' as const, stiffness: 520, damping: 30 };
